<section class="references__container">
 <ng-container *ngIf="references">
  <mat-card *ngFor="let item of references">
    <section class="references__container__header">
      <mat-card-title>{{item.title}}</mat-card-title>
    <mat-card-subtitle>
    <section>
      <p>Publication: <strong>{{item.journal_name}}</strong></p>
      <p>Author(s): <strong>{{item.primary_author}}</strong></p>
      <p>Date: <strong>{{item.pubmed_date | date: 'yyyy-MM-dd'}}</strong>
        DOI: <strong>{{item.doi}}</strong>
        PMID: <strong>{{item.accession_number}}</strong></p>
      <p *ngIf="item.country">Country: <strong>{{item.country}}</strong></p>
      <p *ngIf="item.country" class="references__category">Category: <strong>{{item.category}}</strong></p>
      <p *ngIf="item.country">Keywords: <strong>{{item.keywords}}</strong></p>
      </section>
      <section>
        <div class="altmetric-embed
          altmetric-doi-{{item.doi}}"
          data-badge-popover="left"
          data-badge-type="donut"
          data-hide-no-mentions="true"
          rel="noreferrer"
          data-template="reprintsdesk"
          data-link-target="_blank">
        </div>
      </section>
    </mat-card-subtitle>
    </section>
  <mat-card-content *ngIf="item.abstract">
    <section class="references__abstract">
      <a *ngIf="item.abstract && item.abstract.length > 350"
          mat-button color="primary"
          (click)="item.show = !item.show">
        {{ item.show ? 'Hide Full Abstract' : 'Read Full Abstract'}}
          <mat-icon
            *ngIf="item.show"
            aria-hidden="false"
            aria-label="Show abstract">
            keyboard_arrow_up
          </mat-icon>
          <mat-icon
            *ngIf="!item.show"
            aria-hidden="false"
            aria-label="Hide abstract">
            keyboard_arrow_down
          </mat-icon>
      </a>
      <a *ngIf="item.abstract && item.abstract.length < 350">Abstract</a>
    </section>
      <p *ngIf="item.show">{{item.abstract}}</p>
      <p *ngIf="item.abstract && !item.show">{{item.liteAbstract}}</p>
  </mat-card-content>
  <mat-card-actions>
    <a mat-stroked-button href="https://doi.org/{{item.doi}}" target="_blank" class="external-link">
      <mat-icon aria-hidden="false" aria-label="Read Full-Text">open_in_new</mat-icon>
         Read Full Text
    </a>
  </mat-card-actions>
</mat-card>
 </ng-container>
  <section *ngIf="!references"
    class="references__container__noResults">
    <mat-icon class="mat-18">search</mat-icon>
    <h1>No Results Found</h1>

  </section>

</section>
